var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.form.id ? "编辑资源" : "新增资源",
        visible: _vm._dialogVisible,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm._dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { ref: "listForm", attrs: { model: _vm.form } },
        [
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "菜单名称：",
                  "label-width": "120px",
                  prop: "resourcesName",
                  rules: [
                    {
                      required: true,
                      message: "请输入菜单名称",
                      trigger: "blur",
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入菜单名称", maxlength: 30 },
                  model: {
                    value: _vm.form.resourcesName,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "resourcesName", $$v)
                    },
                    expression: "form.resourcesName",
                  },
                }),
              ],
              1
            ),
          ],
          _c(
            "el-form-item",
            { attrs: { label: "上级资源：", "label-width": "120px" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-start",
                    width: "300",
                    trigger: "click",
                  },
                },
                [
                  _c("el-tree", {
                    staticClass: "tree-wrapper",
                    attrs: {
                      data: _vm.resourceList,
                      props: _vm.resourceProps,
                      "expand-on-click-node": false,
                      "default-expand-all": "",
                    },
                    on: { "node-click": _vm.parentResourceClick },
                  }),
                  _c("el-input", {
                    attrs: { slot: "reference", readonly: "" },
                    on: { focus: _vm.parentResourceFocus },
                    slot: "reference",
                    model: {
                      value: _vm.selectedParentResource.parentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.selectedParentResource, "parentName", $$v)
                      },
                      expression: "selectedParentResource.parentName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "url",
                label: "资源路由：",
                "label-width": "120px",
                rules: [
                  {
                    required: true,
                    message: "资源路由不能为空",
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c(
                "div",
                { staticClass: "tip-icon-wrapper" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请选择资源路由" },
                    model: {
                      value: _vm.form.url,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "url", $$v)
                      },
                      expression: "form.url",
                    },
                  }),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "light", placement: "top-start" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "content",
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(" URL格式： "),
                          _c("br"),
                          _vm._v(
                            "1.常规业务开发的功能URL，如用户管理，views目录下页面路径为 /Sys/User, 此处填写 /sys/user。 "
                          ),
                          _c("br"),
                          _vm._v(
                            "2.嵌套外部网页，如通过菜单打开百度网页，此处填写 http://www.baidu.com，http:// 不可省略。 "
                          ),
                          _c("br"),
                          _vm._v(
                            "示例：用户管理：/sys/user 嵌套百度：http://www.baidu.com 嵌套网页：http://127.0.0.1:8000 "
                          ),
                          _c("br"),
                        ]
                      ),
                      _c("el-icon", { staticClass: "icon el-icon-warning" }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "resourcesCode",
                label: "资源code：",
                "label-width": "120px",
                rules: [
                  {
                    required: true,
                    message: "资源code不能为空",
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "如：sys:user:add,sys:user:edit",
                  maxlength: 24,
                },
                model: {
                  value: _vm.form.resourcesCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "resourcesCode", $$v)
                  },
                  expression: "form.resourcesCode",
                },
              }),
            ],
            1
          ),
          [
            _c(
              "el-form-item",
              { attrs: { label: "排序编号：", "label-width": "120px" } },
              [
                _c("el-input-number", {
                  attrs: { "controls-position": "right", min: 0, max: 120 },
                  model: {
                    value: _vm.form.sort,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "sort", $$v)
                    },
                    expression: "form.sort",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "备注：", "label-width": "120px" } },
              [
                _c("el-input", {
                  attrs: {
                    type: "textarea",
                    rows: 2,
                    maxlength: 200,
                    placeholder: "请输入备注",
                  },
                  model: {
                    value: _vm.form.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "remark", $$v)
                    },
                    expression: "form.remark",
                  },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm._dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.btnLoading,
                size: "small",
              },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }